import { useContext, createContext } from "react";

export type AstreaUtilities = {
  logout: (callback?: () => void) => void | undefined;
};

export const AstreaUtilitiesContext = createContext<AstreaUtilities>({
  logout: undefined,
});

export const useAstreaUtilities = () => useContext(AstreaUtilitiesContext);

export const AstreaUtilitiesProvider = AstreaUtilitiesContext.Provider;
